import {MUTATION_KEYS, QUERY_KEYS} from '@/queryClient'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import {httpDeleteRank} from '../services/rank.http'

export const useDeleteRank = ({onSuccess}: {onSuccess: () => void}) => {
    const client = useQueryClient()
    return useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_RANK],
        mutationFn: (rankId: number[]) => httpDeleteRank(rankId),
        onSuccess: () => {
            onSuccess()
            client.invalidateQueries({queryKey: [QUERY_KEYS.RANKING_LIST]})
        }
    })
}
